module.exports = __webpack_public_path__ + "img/upload-icon.4e62e5d2.svg";